import { Routes } from '@angular/router';
import { AppLayout } from '@layout/component/app.layout';
import { Dashboard } from '@pages/dashboard/dashboard';
import { Documentation } from '@pages/documentation/documentation';
import { Landing } from '@pages/landing/landing';
import { Notfound } from '@pages/notfound/notfound';
import { authGuard } from '@guards/auth-guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: Dashboard },
            { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
            { path: 'documentation', component: Documentation },
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') }
        ]
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
